module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_suns-03f92ccc8880f9598d1732a0b253b339.jpg";